document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-add-to-cart]")
    .forEach((/** @type HTMLButtonElement */ addToCartButton) => {
      addToCartButton.addEventListener("click", () => {
        const f = new FormData();
        f.append("product_id", addToCartButton.dataset.addToCart);
        if (addToCartButton.dataset.stockId) {
          f.append("stock_id", addToCartButton.dataset.stockId);
        }
        f.append("quantity", "1");
        f.append("_token", _globalToken._token);
        fetch(
          window.location.protocol +
            "//" +
            window.location.hostname +
            "/ajax-add-cart",
          {
            method: "POST",
            body: f,
          }
        )
          .then((r) => r.json())
          .then((data) => {
            if (
              !isNaN(Number(data.quantity)) &&
              "updateCartQuantity" in window
            ) {
              window.updateCartQuantity(Number(data.quantity));
            }
            if (data.status && "showToast" in window) {
              window.showToast(
                "Sepete Eklendi",
                "<p>Ürün sepete eklendi.</p>",
                "bg-success"
              );

              if (dataLayer) {
                dataLayer.push({
                  event: "add_to_cart",
                  ecommerce: {
                    currency: "TRY",
                    value: data.price,
                    items: [
                    {
                      item_id: data.product_id,
                      item_name: data.product_name,
                    }
                    ]
                  }
                });
              }

            }
          });
      });
    });
});
